export const productsManagement = {
    state: {
        products: null
    },
    mutations: {
        SET_PRODUCTS(state, products) {
            state.products = products
        }
    },
    actions: {
        fetchProducts({ commit, getters }) {
            return new Promise((resolve, reject) => {
                // TODO check if exist currentAddressWarehouseId
                this.$api.get(`b2b/v2/packages/list/${getters.currentAddressWarehouseId}`).then(response => {
                    commit('SET_PRODUCTS', response.data.data)
                    resolve()
                })
            })
        }
    },
    getters: {
        products: (state) => {
            return state.products
        },
        productById: (state) => (id) => {
            if(state.products) {
                return state.products.find(item => id === item.id)
            }
        },
        modal: (state) => {
            return state.modal
        },
        featuredProducts: (state) => {
            if(state.products) {
                return state.products.filter(item => item.featured === true)
            }
        }
    }
}
